import type { components } from "@/api-schema";
import { RowWithIdentifier } from "@/components/data-table/_helpers/row-identifier";
import { RuleTable } from "@/components/data-table/predefined/rule-table";
import { useTranslation } from "react-i18next";
import { RuleHintDialog } from "./rule-hint-dialog";

type Rule = components["schemas"]["Rule"] & RowWithIdentifier;

const READ_ONLY_ROW_ACTIONS = { showEdit: false, showDelete: false, showRestore: false };

interface GroupRuleSectionProps {
  groupUuid: string;
  canManage: boolean;
  onRuleEdit: (rule: Rule) => void;
}

export function GroupRuleSection({ groupUuid, canManage, onRuleEdit }: GroupRuleSectionProps) {
  const { t } = useTranslation(["ram", "common"]);

  return (
    <div className="mb-6 flex w-full flex-col gap-2">
      <div className="flex items-center justify-between">
        <h2 className="text-lg leading-none font-semibold">{t("ram:Rule")}</h2>
        <RuleHintDialog />
      </div>

      <p className="text-muted-foreground mt-1 text-sm">{t("ram:PermissionRulesThatApplyToThisGroup")}</p>
      <RuleTable
        body={{ group: [groupUuid] }}
        autoFetch={true}
        onEdit={onRuleEdit}
        defaultRowActions={canManage ? undefined : READ_ONLY_ROW_ACTIONS}
        showCreateButton={canManage}
        createButtonLink={`~/ram/group/${groupUuid}/rule/create`}
        createButtonText={t("ram:AddRule")}
        pageSize={5}
        tableClassName="flex max-h-[calc(100svh-24rem)] flex-col"
      />
    </div>
  );
}
